
import ServiceCard from '../service-card/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  name: 'ServiceCardList',
  components: {
    ServiceCard
  },
  mixins: [staticBlockMixin],
  props: {
    pagination: {
      type: Boolean,
      required: false,
      default: false
    },
    arrows: {
      type: Boolean,
      required: false,
      default: false
    },
    isCenter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      // Опции слайдера
      defaultSplideOptions: {
        perMove: 1,
        autoWidth: false,
        gap: 20,
        center: false,
        pagination: false,
        breakpoints: {
          1099: {
            perPage: 4
          },
          1023: {
            perPage: 3,
            arrows: true
          },
          500: {
            perPage: 1,
            arrows: true,
            center: true,
            padding: 90
          }
        }
      },
      isActive: 0,
      maxWidthSlider: '100',
      perSliderValue: 5
    }
  },
  mounted () {
    if (!this.isCenter) { return }
    if (this.blocksByTag.length < 5) {
      this.perSliderValue = this.blocksByTag.length
      this.maxWidthSlider = 100 * this.perSliderValue / 5
    }
  },
  methods: {
    onSplideMove (_, index: number) {
      this.isActive = index
    },
    changeSlide (index: number) {
      this.$refs.splide.go(index)
    },
    mergeSplideOptionsWithDefault () {
      return Object.assign({},
        this.defaultSplideOptions,
        {
          pagination: this.pagination,
          arrows: this.arrows,
          perPage: this.perSliderValue
        }
      )
    }
  }
}
